import React, { FC, Fragment } from 'react';

import './BreadcrumbContainer.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcons } from 'src/constants/fontAwesomeIcons';
import useSelector from 'src/hooks/useSelector';
import Breadcrumb from './Breadcrumb';

const BreadcrumbContainer: FC = () => {

    const breadcrumbs = useSelector(state => state.navigation.breadcrumbs);

    // Method to render the breadcrumbs
    const renderBreadcrumbs = () => {
        return breadcrumbs?.map((breadcrumb, index) => (
            <Fragment key={`breadcrumb-fragment-${index}`}>
                <Breadcrumb 
                    key={`breadcrumb-${breadcrumb.title}-${index}`}
                    breadcrumb={breadcrumb}
                />
                {
                    breadcrumbs?.length !== index + 1 ?
                    <FontAwesomeIcon 
                        key={`chevronright-${index}`}
                        icon={FontAwesomeIcons.Light.CHEVRONRIGHT}
                        style={{
                            margin: '0px 15px'
                        }}
                    /> :
                    <></>
                }
            </Fragment>
        ));
    };
    

    return (
        <div
            className="breadcrumb-container"
            style={{
                visibility: breadcrumbs?.length > 0 ? 'visible' : 'hidden'
            }}
        >
            {renderBreadcrumbs()}
        </div>
    );
}


export default BreadcrumbContainer;